export const getHead = (arr: any[]) => arr[0];
